import { graphql } from 'gatsby';
import ImageZoom from '@/components/ImageZoom';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import { isRichTextValid, resolveDOMNode } from '../../../RichTextBlock/utils';

import {
  StyledBody,
  StyledButton,
  StyledEyebrow,
  StyledHeader,
  StyledHeaderContent,
  StyledHeaderImage,
  StyledHeadline,
  StyledImage,
} from './ColumnBlockHeader.styles';

const ColumnBlockHeader = ({
  body,
  cta,
  eyebrow,
  headline,
  image,
  image_direction,
}: Queries.COLUMN_BLOCK_HEADERFragment) => {
  const imageValue = image?.value && {
    ...image.value,
    width: image.value.width!,
    height: image.value.height!,
  };

  const isHeaderContentVisible = Boolean(
    headline?.value || eyebrow?.value || body?.value || cta?.value
  );
  const isHeaderVisible = Boolean(isHeaderContentVisible || imageValue);
  const hasBody = !!body?.value && isRichTextValid(body.value);

  return isHeaderVisible ? (
    <StyledHeader imageDirection={image_direction?.value} hasNoBody={!body?.value}>
      {isHeaderContentVisible && (
        <StyledHeaderContent>
          {eyebrow?.value && <StyledEyebrow>{eyebrow.value}</StyledEyebrow>}
          {headline?.value && <StyledHeadline>{headline.value}</StyledHeadline>}
          {hasBody && (
            <StyledBody>
              <RichTextElement resolveDomNode={resolveDOMNode} value={body.value} />
            </StyledBody>
          )}
          {cta?.value && <StyledButton {...cta.value} variant="primary" />}
        </StyledHeaderContent>
      )}
      {imageValue && (
        <StyledHeaderImage>
          <ImageZoom width={imageValue.width}>
            <StyledImage
              image={{ ...imageValue, image_id: imageValue.url }}
              width={imageValue.width}
              height={imageValue.height}
            />
          </ImageZoom>
        </StyledHeaderImage>
      )}
    </StyledHeader>
  ) : null;
};

export const fragment = graphql`
  fragment COLUMN_BLOCK_HEADER on kontent_item_column_block_elements {
    cta {
      value {
        ...LINK
      }
    }
    eyebrow {
      value
    }
    headline {
      value
    }
    image {
      value {
        description
        height
        url
        width
      }
    }
    image_direction {
      value
    }
    body {
      value
    }
  }
`;

export default ColumnBlockHeader;
